import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const LeadsCounts = ({ data }: any) => {
  const count = [
    {
      Created: data?.data?.totals?.createdCount,
      InProgress: data?.data?.totals?.inProgressCount,
      Converted: data?.data?.totals?.convertedCount,
    },
  ];
  return (
    <>
      <div>
        <span className="dashboard-heading mb-4">Leads</span>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart layout="vertical" data={count}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" />
          <Tooltip />
          <Legend />
          <Bar dataKey="Created" stackId="a" fill="#8884d8" />
          <Bar dataKey="InProgress" stackId="a" fill="#82ca9d" />
          <Bar dataKey="Converted" stackId="a" fill="#ffc658" />
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default LeadsCounts;
